/* eslint-disable */

export const makeOrderConstants = {
    FETCH_MAKE_ORDER_REQUEST: 'FETCH_MAKE_ORDER_REQUEST',
    FETCH_MAKE_ORDER_SUCCESS: 'FETCH_MAKE_ORDER_SUCCESS',
    FETCH_MAKE_ORDER_FAILURE: 'FETCH_MAKE_ORDER_FAILURE',
};
